<div class="grid">
  <div class="col-12">
    <h3
      *ngIf="currentStep === checkoutStepEnum.PaymentDetails"
      id="pay-invoices-title"
    >
      {{ 'ARC_PAYMENT_DETAILS' | translate }}
    </h3>
    <h3 *ngIf="currentStep === checkoutStepEnum.Review" id="pay-invoices-title">
      {{ 'ARC_PAYMENT_REVIEW' | translate }}
    </h3>
    <label
      class="body"
      id="account-number-label"
      *ngIf="accountNumbers?.length > 1; else singleAccount"
      >{{ 'ARC_PAYMENT_ACCOUNT_NUMBERS_LABEL' | translate }}:
    </label>
    <ng-template #singleAccount>
      <label class="body" id="account-number-label"
        >{{ 'ARC_PAYMENT_ACCOUNT_NUMBER_LABEL' | translate }}:
      </label></ng-template
    >
    <span id="account-number-value">{{ formatAccountNumbers() }} </span>
    <a
      id="account-number-link"
      *ngIf="accountNumbers?.length > maxAccountsToList"
      (click)="isAccountsDialogVisible = true"
      >({{ accountNumbers?.length }} total)</a
    >
  </div>
</div>

<p-dialog
  id="multi-accounts-dialog"
  [(visible)]="isAccountsDialogVisible"
  header="{{ 'ARC_PAYMENT_ACCOUNT_NUMBER_HEADER' | translate }}"
  [resizable]="false"
  [showHeader]="true"
  [modal]="true"
  [responsive]="true"
  showEffect="fade"
  [blockScroll]="true"
  [appendTo]="'body'"
>
  <div class="dialog-body">
    <div *ngFor="let account of accountNumbers">
      <div class="account-numbers-dialog">
        {{ account }}
      </div>
    </div>
  </div>
</p-dialog>
